import axiosInstance from '../config/AxiosConfig'
import {BACKEND_ENDPOINT, NOTIFICATION_ENDPOINT} from '../Constants'

//#region Generic API Endpoints
// Reserved for generic use || For custom use, refer to use your own implementation

export const endpoints = {
    backend: 'backend',
    notification: 'notification',
}

export const notificationPath = {supportTeams: 'supportTeams'}

function getEndpoint(path) {
    let endpoint = BACKEND_ENDPOINT

    for (const key in notificationPath) {
        if (path === notificationPath[key]) {
            return NOTIFICATION_ENDPOINT
        }
    }

    return endpoint
}

export function createOrUpdateGenericInfo(path, userId, data = {}) {
    let ENDPOINT = getEndpoint(path)
    return axiosInstance
        .post(`${ENDPOINT}/${path}/createOrUpdate`, data, {
            params: {userId},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function getGenericInfo(path, userId, id, treatAsRole) {
    let ENDPOINT = getEndpoint(path)
    return axiosInstance
        .get(`${ENDPOINT}/${path}/getById`, {
            params: {userId, id, treatAsRole},
        })
        .then(res => {
            return res.data
        })
        .catch(error => console.log(error))
}

export function getPageGenericInfo(
    path,
    userId,
    pageNumber = 0,
    pageRows = 10,
    sortField = 'id',
    sortOrder = -1,
    filterRequest = {},
) {
    let ENDPOINT = getEndpoint(path)
    return axiosInstance
        .post(`${ENDPOINT}/${path}/getPage`, filterRequest, {
            params: {
                userId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
            },
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function getListGenericInfo(
    path,
    userId,
    filterRequest = {},
    rows,
    dto = false,
    sortField = 'id',
    sortOrder = -1,
) {
    let ENDPOINT = getEndpoint(path)
    return axiosInstance
        .post(`${ENDPOINT}/${path}/getList`, filterRequest, {
            params: {userId, rows, dto, sortField, sortOrder},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function getTreeGenericInfo(
    path,
    userId,
    pageNumber,
    pageRows,
    sortField = 'id',
    sortOrder = -1,
    filterRequest = {},
) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${path}/getTree`, filterRequest, {
            params: {userId, pageNumber, pageRows, sortField, sortOrder},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function deleteGenericInfo(path, userId, id) {
    let ENDPOINT = getEndpoint(path)
    return axiosInstance
        .delete(`${ENDPOINT}/${path}/deleteById`, {
            params: {userId, id},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function clearGenericCache(path, userId, id) {
    let ENDPOINT = getEndpoint(path)
    return axiosInstance
        .delete(`${ENDPOINT}/${path}/clearCache`, {
            params: {userId, id},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function tacAcceptance(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/user/tacAcceptance`, data, {
            params: {userId},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}
//#endregion
